export default __webpack_public_path__ + "static/media/telephone.0157bc23.svg";